module.exports = __webpack_public_path__ + "img/catseye00.3ffc73bc.jpg";